// Prijsconfiguratie - Vaste tarieven per plaats naar luchthaven
// Gebaseerd op marktprijzen met €7,50 vaste opslag

export interface PriceConfig {
  [place: string]: {
    schiphol: number;
    rotterdam: number;
    eindhoven: number;
  };
}

export const PRICING: PriceConfig = {
  'Utrecht Centrum': {
    schiphol: 65.00,
    rotterdam: 77.50,
    eindhoven: 92.50
  },
  'Nieuwegein': {
    schiphol: 67.50,
    rotterdam: 75.00,
    eindhoven: 95.00
  },
  'Houten': {
    schiphol: 70.00,
    rotterdam: 80.00,
    eindhoven: 97.50
  },
  'Zeist': {
    schiphol: 72.50,
    rotterdam: 82.50,
    eindhoven: 100.00
  },
  'De Bilt': {
    schiphol: 67.50,
    rotterdam: 80.00,
    eindhoven: 95.00
  },
  'Bunnik': {
    schiphol: 70.00,
    rotterdam: 82.50,
    eindhoven: 97.50
  },
  'Vianen': {
    schiphol: 72.50,
    rotterdam: 70.00,
    eindhoven: 100.00
  },
  'IJsselstein': {
    schiphol: 70.00,
    rotterdam: 72.50,
    eindhoven: 97.50
  },
  'Woerden': {
    schiphol: 75.00,
    rotterdam: 85.00,
    eindhoven: 102.50
  },
  'Maarssen': {
    schiphol: 62.50,
    rotterdam: 82.50,
    eindhoven: 97.50
  },
  'Breukelen': {
    schiphol: 60.00,
    rotterdam: 85.00,
    eindhoven: 100.00
  },
  'Soest': {
    schiphol: 70.00,
    rotterdam: 85.00,
    eindhoven: 97.50
  },
  'Amersfoort': {
    schiphol: 77.50,
    rotterdam: 92.50,
    eindhoven: 102.50
  },
  'Veenendaal': {
    schiphol: 85.00,
    rotterdam: 97.50,
    eindhoven: 105.00
  },
  'Wijk bij Duurstede': {
    schiphol: 80.00,
    rotterdam: 92.50,
    eindhoven: 105.00
  },
  'Montfoort': {
    schiphol: 77.50,
    rotterdam: 82.50,
    eindhoven: 105.00
  },
  'Lopik': {
    schiphol: 80.00,
    rotterdam: 77.50,
    eindhoven: 107.50
  },
  'Bilthoven': {
    schiphol: 70.00,
    rotterdam: 82.50,
    eindhoven: 97.50
  },
  'Doorn': {
    schiphol: 77.50,
    rotterdam: 90.00,
    eindhoven: 102.50
  },
  'Driebergen': {
    schiphol: 75.00,
    rotterdam: 87.50,
    eindhoven: 100.00
  }
};

export const EXTRAS = {
  stationwagon: 7.50,
  extraStop: 7.50,
  childSeat: 5.00
};

export const VEHICLE_TYPES = {
  sedan: {
    name: 'Sedan',
    capacity: 4,
    surcharge: 0,
    description: '1-4 personen • Standaard bagage'
  },
  stationwagon: {
    name: 'Stationwagon',
    capacity: 4,
    surcharge: 7.50,
    description: '1-4 personen • Extra bagage'
  },
  taxibus: {
    name: 'Taxibus',
    capacity: 8,
    surcharge: 20.00,
    description: '5-8 personen • Ruime bagage'
  }
};

export const AIRPORTS = {
  schiphol: 'Schiphol Airport',
  rotterdam: 'Rotterdam The Hague Airport',
  eindhoven: 'Eindhoven Airport'
};

export function calculatePrice(
  place: string,
  airport: keyof typeof AIRPORTS,
  vehicleType: keyof typeof VEHICLE_TYPES,
  passengers: number,
  childSeats: number = 0,
  extraStops: number = 0
): number {
  const basePrice = PRICING[place]?.[airport] || 0;
  
  let vehicleSurcharge = 0;
  if (vehicleType === 'stationwagon') {
    vehicleSurcharge = EXTRAS.stationwagon;
  } else if (vehicleType === 'taxibus') {
    vehicleSurcharge = 20.00;
  }
  
  const childSeatCost = childSeats * EXTRAS.childSeat;
  const extraStopCost = extraStops * EXTRAS.extraStop;
  
  return basePrice + vehicleSurcharge + childSeatCost + extraStopCost;
}
